import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	numberRangePlaceholderMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minimumClauseLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	maximumClauseLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	triggerValueBothClauses: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	triggerValueMinimumClause: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	triggerValueMaximumClause: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	validNumberErrorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	numberSizeLimitErrorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	numberRangeErrorMinimumClauseMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	numberRangeErrorMaximumClauseMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	updateButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	numberRangePlaceholderMessage: {
		id: 'jql-builder-basic.jql-editor.field.number-range-picker.number-range-placeholder-message',
		defaultMessage: 'Enter a number',
		description: 'Placeholder for the number range picker input',
	},
	minimumClauseLabel: {
		id: 'jql-builder-basic.jql-editor.field.number-range-picker.minimum-clause-label',
		defaultMessage: 'Minimum',
		description: 'Label of the minimum clause in the number range picker',
	},
	maximumClauseLabel: {
		id: 'jql-builder-basic.jql-editor.field.number-range-picker.maximum-clause-label',
		defaultMessage: 'Maximum',
		description: 'Label of the maximum clause in the number range picker',
	},
	triggerValueBothClauses: {
		id: 'jql-builder-basic.jql-editor.field.number-range-picker.trigger-value-both-clauses',
		defaultMessage: 'From {min} to {max}',
		description:
			'Displayed in number range picker text to indicate we are showing data between two float values',
	},
	triggerValueMinimumClause: {
		id: 'jql-builder-basic.jql-editor.field.number-range-picker.trigger-value-minimum-clause',
		defaultMessage: 'From {min}',
		description:
			'Displayed in number range picker text to indicate we are showing data greater than or equal to a float value',
	},
	triggerValueMaximumClause: {
		id: 'jql-builder-basic.jql-editor.field.number-range-picker.trigger-value-maximum-clause',
		defaultMessage: 'Up to {max}',
		description:
			'Displayed in number range picker text to indicate we are showing data less than or equal to a float value',
	},
	validNumberErrorMessage: {
		id: 'jql-builder-basic.jql-editor.field.number-range-picker.valid-number-error-message',
		defaultMessage: 'Please enter a valid number',
		description: 'Display error when the user has entered an invalid number',
	},
	numberSizeLimitErrorMessage: {
		id: 'jql-builder-basic.jql-editor.field.number-range-picker.number-size-limit-error-message',
		defaultMessage: 'Specify a number for the custom field (below {maxSize})',
		description: 'Display error when the user has exceeded the number size limit',
	},
	numberRangeErrorMinimumClauseMessage: {
		id: 'jql-builder-basic.jql-editor.field.number-range-picker.number-range-error-minimum-clause-message',
		defaultMessage: 'The minimum must be less than the maximum',
		description: 'Display error when the user requests an invalid minimum number',
	},
	numberRangeErrorMaximumClauseMessage: {
		id: 'jql-builder-basic.jql-editor.field.number-range-picker.number-range-error-maximum-clause-message',
		defaultMessage: 'The maximum must be greater than the minimum',
		description: 'Display error when the user requests an invalid maximum number',
	},
	updateButtonText: {
		id: 'jql-builder-basic.jql-editor.field.number-range-picker.update-button-text',
		defaultMessage: 'Update',
		description: 'Label of button used to update specified number range criteria',
	},
});

export default messages;
